module.exports = __webpack_public_path__ + "static/media/artem_v.a5e9b036.jpg";